export const MIN_EVENTS_ROWS_QUANTITY = 2;
export const MIN_UNASSIGNED_ROWS_QUANTITY = 1;
